import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CalendarState {
    viewMode: "month" | "week" | "day";
}
const initialState: CalendarState = {
    viewMode: "week",
};

export const calendarSlice = createSlice({
    name: "calendar",
    initialState,
    reducers: {
        setViewMode: (state, action: PayloadAction<"month" | "week" | "day">) => {
            state.viewMode = action.payload;
        },
    },
});
